<ng-container *ngIf="selectedChannel">
    <div class="container">
        <div class="header">
            <div class="title">
                {{ 'output-settings.DO.dialog.title' | translate }}
            </div>
            <button class="text-button not-padding" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
        </div>
        <div class="content-container">
            <div class="configuration">
                {{ 'output-settings.DO.dialog.configuration' | translate }}
            </div>
            <div class="channel-container">
                <div>
                    {{ 'output-settings.DO.dialog.channel-header' | translate }}
                </div>
                <div class="channel">
                    <div class="channel-header">
                        <h6 class="channel-title">
                            {{ selectedChannel.opsData.name }}
                        </h6>
                        <span class="channel-type">
                            {{ selectedChannel.opsData.channelType }}
                        </span>
                    </div>
                    <div class="channel-content" *ngIf="!isDigitalChannel()">
                        <div class="range">
                            <div>
                                {{ 'output-settings.DO.dialog.measuring-range' | translate }}
                            </div>
                            <div class="range-value">
                                {{ getMeasurableRangeStr() }}
                            </div>
                        </div>

                        <div
                            *ngIf="selectedChannel.fcuData.normalRange.max || selectedChannel.fcuData.normalRange.min"
                            class="range">
                            <div>
                                {{ 'output-settings.DO.dialog.normal-range' | translate }}
                            </div>
                            <div class="normal-range">
                                {{ getNormalRangeStr() }}
                            </div>
                        </div>

                        <ng-container *ngFor="let alarm of alarmSettings">
                            <div *ngIf="selectedChannel.fcuData[alarm].enable" class="range">
                                <div>
                                    {{ selectedChannel.fcuData[alarm].statusString }}
                                </div>
                                <div class="range-value">
                                    {{ getAlarmRangeStr(alarm) }}
                                </div>
                            </div>
                        </ng-container>
                    </div>
                    <div class="channel-footer">
                        <button class="text-button not-padding" (click)="selectChannel()">
                            {{ 'output-settings.DO.dialog.change-channel' | translate }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="signal-type-selectors-text">
                {{ 'output-settings.DO.dialog.signal-type-text' | translate }}
            </div>
            <div class="selector-wrapper">
                <div
                    class="selector-fieldset"
                    [class.focusFieldset]="isTriggerConditionOpen"
                    (click)="openTriggerCondition($event)"
                    [class.hasError]="hasTriggerError"
                    #triggerSelElement>
                    <div class="selector-legend" *ngIf="isTriggerConditionOpen">
                        {{ 'output-settings.DO.dialog.trigger-condition.legend' | translate }}
                    </div>
                    <div class="selector-container">
                        <ng-container
                            *ngTemplateOutlet="selectorTemplate; context: { displayValue: geDisplayValue() }" />
                    </div>
                </div>
                <ng-container *ngIf="hasTriggerError">
                    <div class="error-message">
                        {{ 'errors.validation.generic.missing-required' | translate }}
                    </div>
                </ng-container>
            </div>

            <ng-container *ngIf="triggerCondition; else emptySpace">
                <div class="selector-wrapper">
                    <div
                        class="selector-fieldset"
                        [class.focusFieldset]="isOptionsOpen"
                        (click)="openOptions($event)"
                        [class.hasError]="hasOptionError"
                        #optionsSelElement>
                        <div class="selector-legend" *ngIf="isOptionsOpen">
                            {{ getOptionsLegend() | translate }}
                        </div>
                        <div class="selector-container">
                            <ng-container
                                *ngTemplateOutlet="
                                    multipleSelectorTemplate;
                                    context: {
                                        displayValue: getMultpleDisplayValue(),
                                        options: getOptions(),
                                        placeholder: getOptionsLegend(),
                                    }
                                " />
                        </div>
                    </div>
                    <ng-container *ngIf="hasOptionError">
                        <div class="error-message">
                            {{ 'errors.validation.generic.missing-required' | translate }}
                        </div>
                    </ng-container>
                </div>
            </ng-container>
        </div>
        <div class="footer">
            <div class="step-text">
                {{ 'output-settings.DO.dialog.step' | translate }}
            </div>
            <div class="footer-left">
                <div class="text-button" (click)="selectChannel()">
                    {{ 'output-settings.DO.dialog.back' | translate }}
                </div>
                <div class="text-button save-button" (click)="save()" [class.save-disable]="isSaveDisabled()">
                    {{ 'output-settings.DO.dialog.save' | translate }}
                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Selector template -->
<ng-template #selectorTemplate let-displayValue="displayValue">
    <div [class.selected]="displayValue">
        {{
            displayValue
                ? (displayValue.key | translate)
                : isTriggerConditionOpen
                  ? ''
                  : ('output-settings.DO.dialog.trigger-condition.legend' | translate)
        }}
    </div>
    <mat-icon class="arrow" svgIcon="dropdown-arrow" />
    <ng-container *ngIf="isTriggerConditionOpen">
        <div
            class="options-wrapper"
            #selectorElement
            [style.top]="optionsTop"
            [style.left]="optionsLeft"
            [style.width]="optionsWidth">
            <div
                *ngFor="let option of triggerConditions"
                class="selector-option"
                (click)="triggerConditionSelected(option); $event.stopPropagation()"
                [class.selectedOption]="displayValue == option"
                [class.disable]="isOptionDisabled(option.value)"
                style="pointer-events: unset !important">
                <div>
                    {{ option.key | translate }}
                </div>
                <ng-container *ngIf="displayValue == option">
                    <mat-icon class="small-icon" svgIcon="tick" />
                </ng-container>
            </div>
        </div>
    </ng-container>
</ng-template>

<!-- Multiple selector template -->
<ng-template
    #multipleSelectorTemplate
    let-displayValue="displayValue"
    let-options="options"
    let-placeholder="placeholder">
    <div [class.multiple-options]="displayValue">
        {{ displayValue ? displayValue : isOptionsOpen ? '' : (placeholder | translate) }}
    </div>
    <mat-icon class="arrow" svgIcon="dropdown-arrow" />
    <ng-container *ngIf="isOptionsOpen">
        <div class="options-wrapper" [style.top]="optionsTop" [style.left]="optionsLeft" [style.width]="optionsWidth">
            <div
                *ngFor="let option of options"
                class="multiple-option-row"
                (click)="multipleOptionSelected(option); $event.stopPropagation()">
                <mat-checkbox class="checkbox" [checked]="isOptionSelected(option)" />
                <div>{{ getCheckboxText(option) | translate }}</div>
            </div>
        </div>
    </ng-container>
</ng-template>

<ng-template #emptySpace>
    <div class="empty-space"></div>
</ng-template>
